import { SearchRoute } from '../../../../../app.routes.config';

export class PotentialSearchActionSd {
  '@type' = 'SearchAction';
  target = '';
  'query-input' = 'required name=query';

  constructor(baseUrl: string) {
    this.target = baseUrl + '/' + SearchRoute + '?q={query}';
  }
}
